import zhanqun from "../apis/zhanqun"
import MixinSite from "@/mixins/site";

export default {
    mixins: [MixinSite],
    data() {
        return {
            tikuHomeUrl: '',
            title: zhanqun.hotPaperTitle(),
            lists: [],
        };
    },
    created() {
        this.tikuHomeUrl = this.getHomePageUrl(this.urlParams)
    },
    mounted() {
        this.loadRightHotPapaer()
        zhanqun.trackEvent('show_pcsitedetail_sidebar_recommendations', {
            visit_channel: this.currentSiteInfo.domain
        })
    },
    methods: {
        buildPaperUrl: function (id, params = {}) {
            return this.isMobile ? zhanqun.buildMobilePaperUrl(id, params) : zhanqun.buildPcPaperUrl(id, params)
        },
        getHomePageUrl(params={}){
            return this.isMobile ? zhanqun.getMobileHomePageUrl(params) : zhanqun.getPcHomePageUrl(params)
        },
        handleRightHotPaperClick: function (item,index) {
            zhanqun.trackEvent('click_pcsitedetail_sidebar_recommendations', {
                visit_channel: this.currentSiteInfo.domain,
                paper_name: item.name,
                paper_id: item.id,
                location:index
            })
        },
        loadRightHotPapaer() {
            zhanqun
                .queryHotPaper(this.currentSiteInfo.hotPaperParams)
                .then((res) => {
                    let tempList = res.data.list;
                    for (let index in tempList) {
                        tempList[index].url = this.buildPaperUrl(
                            tempList[index].id,
                            this.urlParams
                        );
                    }
                    this.lists = tempList;
                });
        }
    }
}
